export enum CatalogStateType {
  CheckCatalog = '1',
  DownloadCatalog = '2'
}

export type ParamsCatalogStateSave = {
  idOpenCatalog: number;
  nameOpenCatalog?: string;
  idUser?: number;
  type: CatalogStateType;
};

export type NextToMeData = {
  isNextMeData: boolean;
  radius?: number;
  longitude?: number;
  latitude?: number;
};

export type BodyReq = {
  [key: string]: any;
} & any;

export type HistoryParams = {
  epoch: string;
  timestamp: 1;
};
